'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dom = {
  productTile: 'data-product-link',
  productATC: 'data-product-atc',
  productImpression: 'data-product-impression'
};

var uniqueEventId = function uniqueEventId() {
  return new Date().getTime() + '.' + Math.random().toString(36).substring(5);
};

var trackCartScripApplied = exports.trackCartScripApplied = function trackCartScripApplied(loadingTime) {
  setTimeout(function () {
    var items_discounts = CartJS.cart.items.map(function (item) {
      return item.discounts[0];
    });
    if (!items_discounts[0]) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'cartScriptApplied',
      'scriptDetails': items_discounts[0].title
    });
  }, loadingTime);
};

var productAttrForDataLayer = exports.productAttrForDataLayer = function productAttrForDataLayer(_ref) {
  var product = _ref.product,
      categoryTitle = _ref.categoryTitle,
      selectedVariantId = _ref.selectedVariantId,
      getJson = _ref.getJson,
      listValue = _ref.listValue;

  selectedVariantId = typeof selectedVariantId !== 'undefined' && selectedVariantId !== null ? selectedVariantId * 1 : product.variants[0].id;
  var selectedProductVariant = product.variants.find(function (variant) {
    return variant.id === selectedVariantId;
  });
  var jsonForDataLayer = {
    item_id: selectedProductVariant.id,
    shopify_product_id: product.id,
    shopify_variant_id: selectedProductVariant.id,
    shopify_sku: typeof selectedProductVariant.sku !== 'undefined' ? selectedProductVariant.sku.replace(/\"/g, "”").replace(/\'/g, "´") : '',
    shopify_handle: product.handle.replace(/\"/g, "”").replace(/\'/g, "´"),
    shopify_compare_price: Number(product.comparePrice),
    item_name: product.title.replace(/\"/g, "”").replace(/\'/g, "´"),
    affiliation: window.theme.strings.affiliation,
    currency: window.bvaccel.currency.currencyCode,
    item_brand: product.vendor.replace(/\"/g, "”").replace(/\'/g, "´"),
    item_category: product.type.replace(/\"/g, "”").replace(/\'/g, "´"),
    item_list_id: listValue || null,
    item_list_name: 'product',
    item_variant: selectedProductVariant.title.replace(/\"/g, "”").replace(/\'/g, "´"),
    item_featured_image: selectedProductVariant.featured_image,
    option_one: selectedProductVariant.option1,
    option_two: selectedProductVariant.option2,
    option_three: selectedProductVariant.option3,
    price: Number(product.priceWithoutCurrency) || Number(product.price / 100),
    quantity: 1
  };
  if (typeof categoryTitle !== 'undefined') {
    jsonForDataLayer.item_category = categoryTitle.replace(/\"/g, "”").replace(/\'/g, "´");
  }
  if (typeof getJson !== 'undefined' && getJson === true) {
    return jsonForDataLayer;
  }
  var attrValue = JSON.stringify(jsonForDataLayer);
  return attrValue;
};

var recordProductImpressions = function recordProductImpressions() {

  /* DATALAYER: All Pages - Product Impressions */

  var productImpressionsElements = document.querySelectorAll('[' + dom.productImpression + '], [' + dom.productTile + ']');
  var impressions = [];
  var impressionItemLocationRef = '';
  var impressionItemIndexRef = -1;
  var impressionPage = void 0;
  var impressionPageHandle = void 0;

  if (document.body.classList.contains('template-index')) {
    impressionPage = 'index';
    impressionPageHandle = 'index';
  }
  if (document.body.classList.contains('template-collection')) {
    impressionPage = 'collection';
    impressionPageHandle = window.bvaccel.collection.handle;
  }
  if (document.body.classList.contains('template-product')) {
    impressionPage = 'product';
    impressionPageHandle = window.bvaccel.product.handle;
  }
  if (document.body.classList.contains('template-page')) {
    impressionPage = 'page';
    impressionPageHandle = window.bvaccel.page.handle;
  }
  if (document.body.classList.contains('template-cart')) {
    impressionPage = 'cart';
    impressionPageHandle = 'cart';
  }
  var impressionItemLocation = void 0;
  productImpressionsElements.forEach(function (productElement) {
    if (productElement.closest('.inline-cart') !== null && !productElement.closest('.inline-cart').classList.contains('is-open')) return;
    var productDataLayerAttribute = productElement.getAttribute(dom.productImpression) !== null ? dom.productImpression : dom.productTile;
    var impressionItem = JSON.parse(productElement.getAttribute(productDataLayerAttribute));

    if (!productElement.closest('[data-layer-list]')) {
      impressionPageHandle = 'collection-list';
    } else {
      var impressionPageSection = productElement.closest('[data-layer-list]');
      impressionPageHandle = impressionPageSection.getAttribute('data-layer-list');
    }
    if (productElement.closest('.inline-cart.is-open') !== null) {
      if (productElement.closest('[data-upsell-product]')) {
        impressionItemLocation = 'inline-cart-cross-sell';
      } else {
        impressionItemLocation = 'inline-cart';
      }
    }
    if (productElement.closest('[data-collection-product-content]') !== null) {
      impressionItemLocation = 'collection-list';
      impressionPageHandle = window.bvaccel.collection.handle;
    }
    if (productElement.closest('.related-products__carousel-wrapper') !== null) {
      impressionItemLocation = 'product';
    }
    if (productElement.closest('.quickshop__related') !== null) {
      impressionItemLocation = 'quickshop-modal';
    }

    if (impressionItemLocation === impressionItemLocationRef) {
      impressionItemIndexRef += 1;
    } else {
      impressionItemLocationRef = impressionItemLocation;
      impressionItemIndexRef = 1;
    }

    impressionItem.item_list_id = impressionPageHandle;
    impressionItem.index = impressionItemIndexRef;
    impressionItem.item_list_name = impressionItemLocation;

    impressions.push(impressionItem);
  });

  if (impressions.length > 0) {
    dataLayer.push({
      event: 'acn_view_item_list',
      event_id: uniqueEventId(),
      ecommerce: {
        currency: window.bvaccel.currency.currencyCode,
        item_list_id: impressionPageHandle,
        item_list_name: impressionItemLocation,
        items: impressions.slice(0, 25)
      }
    });
  }
};

var recordInlineCartProduct = function recordInlineCartProduct() {
  var productImpressionsElements = document.querySelectorAll('[' + dom.productImpression + ']');
  var cartImpressions = [];
  var impressionItemLocationRef = '';
  var impressionItemIndexRef = -1;
  var impressionPage = void 0;
  var impressionPageHandle = void 0;

  if (document.body.classList.contains('template-index')) {
    impressionPage = 'index';
    impressionPageHandle = 'index';
  }
  if (document.body.classList.contains('template-collection')) {
    impressionPage = 'collection';
    impressionPageHandle = window.bvaccel.collection.handle;
  }
  if (document.body.classList.contains('template-product')) {
    impressionPage = 'product';
    impressionPageHandle = 'product';
  }
  if (document.body.classList.contains('lxix-product-page')) {
    impressionPage = 'lxix-product';
    impressionPageHandle = 'lxix-product';
  }
  if (document.body.classList.contains('template-page')) {
    impressionPage = 'page';
    impressionPageHandle = window.bvaccel.page.handle;
  }
  productImpressionsElements.forEach(function (productElement) {
    if (productElement.closest('.inline-cart') === null && productElement.closest('.lxix-minicart-modal') === null) return;
    var productDataLayerAttribute = productElement.getAttribute(dom.productImpression) !== null ? dom.productImpression : dom.productTile;
    var impressionItem = JSON.parse(productElement.getAttribute(productDataLayerAttribute));

    var impressionItemLocation = void 0;
    if (productElement.closest('.inline-cart') !== null) {
      if (productElement.closest('[data-upsell-product]')) {
        impressionItemLocation = 'inline-cart-cross-sell';
      } else {
        impressionItemLocation = 'inline-cart';
      }
    } else if (productElement.closest('.lxix-minicart-modal')) {
      impressionItemLocation = 'lxix-minicart';
    }
    if (impressionItemLocation === impressionItemLocationRef) {
      impressionItemIndexRef += 1;
    } else {
      impressionItemLocationRef = impressionItemLocation;
      impressionItemIndexRef = 1;
    }

    impressionItem.item_list_id = impressionPageHandle;
    impressionItem.index = impressionItemIndexRef;
    impressionItem.item_list_name = impressionItemLocation;

    cartImpressions.push(impressionItem);
  });

  if (cartImpressions.length > 0) {
    dataLayer.push({
      event: 'acn_view_item_list',
      event_id: uniqueEventId(),
      ecommerce: {
        impressions: cartImpressions
      }
    });
  }
};

var bindUiActions = function bindUiActions() {
  /* DATALAYER: All Pages - Product Link Clicks */
  document.addEventListener('click', function (event) {
    var target = false;
    if (event.target.matches('[' + dom.productTile + ']')) target = event.target;
    if (event.target.closest('[' + dom.productTile + ']')) target = event.target.closest('[' + dom.productTile + ']');
    if (!target) return;

    var listValue = window.bvaccel.collection.handle;

    if (target.closest('.inline-cart')) {
      if (target.closest('[data-upsell-product]')) {
        listValue = 'inline-cart-cross-sell';
      } else {
        listValue = 'inline-cart';
      }
    } else if (target.closest('body.template-index') !== null || target.closest('body.template-product')) {
      if (!target.closest('[data-layer-list]')) {
        listValue = 'collection-list';
      } else {
        var listValueSection = target.closest('[data-layer-list]');
        listValue = listValueSection.getAttribute('data-layer-list');
      }
    }

    var productJsonStringForProductClick = target.getAttribute(dom.productTile);
    if (!productJsonStringForProductClick) return;

    var productJsonForProductClick = JSON.parse(productJsonStringForProductClick);
    var anchorHref = target.getAttribute('href');
    var handleMatch = anchorHref === null ? null : anchorHref.match(/products\/([a-z0-9\-]+)/);
    var handle = handleMatch === null ? null : handleMatch[1];
    if (!handle) return;

    dataLayer.push({
      event: 'acn_select_item',
      event_id: uniqueEventId(),
      ecommerce: {
        currency: window.theme.strings.general.currency_code,
        item_list_id: listValue,
        item_list_name: listValue,
        items: [productJsonForProductClick]
      }
    });
  });

  /* DATALAYER: All Pages - Add To Cart Clicks */
  document.addEventListener('click', function (event) {
    var target = false;
    if (event.target.matches('[' + dom.productATC + ']')) target = event.target;
    if (event.target.closest('[' + dom.productATC + ']')) target = event.target.closest('[' + dom.productATC + ']');
    if (!target) return;

    var listValue = window.bvaccel.collection.handle || window.bvaccel.product.handle;
    if (target.closest('.inline-cart')) {
      if (target.closest('[data-upsell-product]')) {
        listValue = 'inline-cart-cross-sell';
      } else {
        listValue = 'inline-cart';
      }
    } else if (target.closest('body.template-product') !== null) {
      listValue = 'product';
    } else if (target.closest('body.template-index') !== null) {
      if (!target.closest('[data-layer-list]')) {
        listValue = 'homepage-collection-list';
      } else {
        var listValueSection = target.closest('[data-layer-list]');
        listValue = listValueSection.getAttribute('data-layer-list');
      }
    }
    var productHandleForAtcClick = target.getAttribute(dom.productATC) || window.bvaccel.product.handle;
    var productVariantIdForAtcClick = target.getAttribute('data-atc');
    if (!productHandleForAtcClick) return;
    fetch('/products/' + productHandleForAtcClick + '?view=datalayer').then(function (res) {
      return res.json();
    }).then(function (res) {
      var productJsonForAtcClick = productAttrForDataLayer({
        product: res.productData,
        categoryTitle: res.productCollection.title,
        selectedVariantId: productVariantIdForAtcClick,
        getJson: true,
        listValue: listValue
      });
      dataLayer.push({
        event: 'acn_add_to_cart',
        event_id: uniqueEventId(),
        ecommerce: {
          currency: window.bvaccel.currency.currencyCode,
          value: Number((res.productData.price / 100).toFixed(2)),
          items: [productJsonForAtcClick]
        }
      });
    }).then(function () {
      setTimeout(function () {
        recordInlineCartProduct();
      }, 1000);
    }).catch(console.error);
  });

  window.addEventListener('load', function (event) {
    recordProductImpressions();
  });
  if (document.querySelector('.navigation-icon--cart')) {
    document.querySelector('.navigation-icon--cart').addEventListener('click', function (event) {
      setTimeout(function () {
        return recordInlineCartProduct();
      }, 1000);
    });
  }
};

var setup = function setup() {
  bindUiActions();
};

exports.default = {
  setup: setup
};